// Shared open/close state for the global "Ask Insiders" command palette
// (Cmd+K). Both the keybinding handler inside the palette component and the
// floating launcher on /dashboard flip the same flag so opening from either
// surface lands on the same modal.
//
// Backed by useState so the value survives across components and SSR/CSR.
export const useAskPalette = () => {
  const isOpen = useState<boolean>('ask:palette-open', () => false);

  const open = () => {
    isOpen.value = true;
  };

  const close = () => {
    isOpen.value = false;
  };

  const toggle = () => {
    isOpen.value = !isOpen.value;
  };

  return {
    isOpen: readonly(isOpen),
    // Expose the raw ref for v-if/v-model uses where readonly() would break.
    // The actions above remain the canonical mutators.
    isOpenRef: isOpen,
    open,
    close,
    toggle,
  };
};
